import { useTranslation } from 'react-i18next';

import { Typography } from '@components/atoms/Typography';
import { showAmount } from '@utils/currency';

import { TProductItemProps } from './types';

const ProductItem = ({ item, currency }: TProductItemProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex gap-2 p-4 rounded-lg bg-[#F9FAFB] hover:bg-[#F4F4F6]">
      <div className="flex-1 min-w-0">
        <Typography text={item.name} className="text-[16px]" weight={500} />
        <Typography text={item.description} className="text-[14px] text-[#64748B]" />

        {item.amount && item.amount > 1 && (
          <div className="flex">
            <Typography
              text={`${t('Checkout.quantity')}: ${item.amount}`}
              className="text-[14px] text-[#64748B]"
            />
          </div>
        )}
      </div>
      <div className="flex-shrink-0 font-semibold text-foreground">
        <Typography
          text={showAmount({
            value: item.price,
            currency: currency,
          })}
          className="text-[16px]"
          weight={500}
        />
      </div>
    </div>
  );
};

export default ProductItem;
